/** 页眉、页脚共用的请求去重器：仅复用同一页面加载期间的进行中请求。 */
const pendingRequests = Object.create(null);

/**
 * 获取布局公共接口数据，页面刷新或请求结束后都会重新获取最新数据。
 * @param {string} name 请求名称。
 * @param {Function} request 发起接口请求的函数。
 * @returns {Promise<any>} 接口返回数据。
 */
export function getLayoutData(name, request) {
  if (pendingRequests[name]) return pendingRequests[name];

  pendingRequests[name] = Promise.resolve()
    .then(request)
    .finally(() => {
      delete pendingRequests[name];
    });

  return pendingRequests[name];
}
